import React from 'react';
import { marked } from 'marked';
import DOMPurify from 'dompurify';

const ModuleArticle = (props) => {
    const { content } = props;

    if (!content) {
        return null;
    }

    const getMarkdownText = () => {
        // marked's `{ sanitize: true }` was a DEAD no-op (removed in marked v1+),
        // so module HTML was injected unsanitized. Sanitize the rendered output
        // with DOMPurify instead (X2).
        const rawMarkup = marked(content);
        return { __html: DOMPurify.sanitize(rawMarkup) };
    };

    return (
        <div id="module-article" dangerouslySetInnerHTML={getMarkdownText()} />
    );
};

export default ModuleArticle;
